import { ActivityPointRankMyDto } from '@diritto/common/activityPoint/dtos/activity-point.dtos';
import { ProfileLiteRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { useAuthState } from 'contexts/AuthProvider';
import { usePathname } from 'next/navigation';
import { useGetActivityPointRankExcludedQuery } from 'queries/activityPoint/useGetActivityPointRankExcludedQuery';
import React from 'react';
import { getExcludedRankText } from 'state-hooks/activityPoint/useActivityPointReward';
import { CertificateLink } from 'ui-components/common/CertificateLink';
import { ContentBodyContainer } from 'ui-components/layout/containers/ContentBodyCenterContainer';
import { buildCertificateUrl } from 'utils/url';

export const RankingMyInfo = ({
  activityPointMyRank,
  profileLites,
}: {
  activityPointMyRank: ActivityPointRankMyDto[];
  profileLites: Record<string, ProfileLiteRelayDto>;
}) => {
  const pathname = usePathname();
  const { isLoggedIn, user, isLoaded } = useAuthState();
  const { data: rankExcludedData } = useGetActivityPointRankExcludedQuery();
  const profileId = activityPointMyRank.find(rank => !!rank.rank)?.profileId;
  const profile = profileId && profileLites[profileId];
  const needCertification = isLoaded && isLoggedIn && !user?.ageVerified;

  return (
    <ContentBodyContainer>
      <StyledRankingInfoList>
        <li>랭킹에는 한 계정에서 제일 높은 점수의 프로필만 집계돼요.</li>
        <li>높은 점수의 프로필이 중복되면 먼저 생성된 프로필로 집계돼요.</li>
        {rankExcludedData?.activityPointRankExcluded ? (
          <li>{getExcludedRankText(rankExcludedData.activityPointRankExcluded)}</li>
        ) : (
          profile && !profile.isDeleted && <li>현재 ‘{profile.nickname}&apos; 프로필이 랭킹에 집계되고 있어요.</li>
        )}
        <li>랭킹은 시즌별로 초기화돼요.</li>
        <li>시즌별 리워드는 계속 변경돼요.</li>
        <li>정해진 시즌까지 순위를 유지하면 리워드를 받을 수 있어요.</li>
        <li>연재 응원 이벤트 작품에서는 이벤트가 진행되는 시간 동안 모든 퀘스트 점수를 획득할 수 없어요.</li>
        <li>출석체크 읽기 작품에는 제한이 없어요(하지만 추후 변동될 수 있어요).</li>
        {needCertification && (
          <li>
            리워드를 받으려면{' '}
            <StyledCertificateLink href={buildCertificateUrl(pathname ?? '')}>본인인증</StyledCertificateLink>이 되어
            있어야 해요.
          </li>
        )}
      </StyledRankingInfoList>
    </ContentBodyContainer>
  );
};

const StyledCertificateLink = styled(CertificateLink)`
  border-bottom: 1px solid ${Color.Gray500};
`;

const StyledRankingInfoList = styled.ul`
  list-style: disc;
  margin-left: 16px;
  margin-top: 24px;

  color: ${Color.Gray500};
  font-weight: ${FontWeight.Medium};
  ${Typography.XXSmall};

  li {
    margin-top: 4px;
  }
`;
